"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    type: "object",
    properties: {
        heartRate: { type: "number", title: "Heart Rate" },
        bpSit: { type: "number", title: "Blood Pressure (Sit)" },
        bpStand: { type: "number", title: "Blood Pressure (Stand)" },
        repositoryRate: { type: "number", title: "Respiratory Rate" },
        temperature: { type: "number", title: "Temperature" },
        pulseOximetry: { type: "number", title: "Pulse Oximetry" },
        pain: { type: "number", title: "Pain" },
        location: { type: "string", title: "Affected Body Parts" },
        weight: { type: "number", title: "Weight" },
        weightUnit: {
            type: "string",
            default: "LBS",
            oneOf: [
                { const: "LBS", title: "LBS" },
                { const: "KG", title: "KG" },
            ],
        },
        bloodSugar: { type: "number", title: "Blood Sugar" },
        bloodSugarType: {
            type: "string",
            default: "Fasting",
            oneOf: [
                { const: "Fasting", title: "Fasting" },
                { const: "Regular", title: "Regular" },
            ],
        },
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    anyOf: [
        { required: ["heartRate"] },
        { required: ["bpSit"] },
        { required: ["bpStand"] },
        { required: ["repositoryRate"] },
        { required: ["temperature"] },
        { required: ["pulseOximetry"] },
        { required: ["pain"] },
        { required: ["location"] },
        { required: ["weight"] },
        { required: ["bloodSugar"] },
    ],
};
